/* eslint-disable react-hooks/rules-of-hooks */
import { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { throttle } from '@next-common/shared-util';
import { addMdFromUserAgent } from '../md/actions';
import { BreakpointContext } from '../components/BreakpointContext/BreakpointContext';
const getBreakPointFromCss = () => window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/"/g, '');
const getDefaultBreakpoint = (md) => {
    let breakpoint = 'desktop';
    if (typeof window !== 'undefined') {
        breakpoint = getBreakPointFromCss();
    }
    else if (md) {
        if (md.isLandscape) {
            // emulated landscape
            breakpoint = 'landscape';
        }
        if (md.isWide) {
            // emulated wide
            breakpoint = 'wide';
        }
        if (md.isMax) {
            // emulated max
            breakpoint = 'max';
        }
        else if (md.tablet) {
            // from mobile-detect
            breakpoint = 'tablet';
        }
        else if (md.mobile) {
            // from mobile-detect
            breakpoint = 'phone';
        }
    }
    return breakpoint;
};
const mdMatchesBrowserCheck = (md) => {
    if (typeof window === 'undefined') {
        return true; // on SSR rendering
    }
    return md && md.userAgent === window.navigator.userAgent;
};
export const breakpointHook = (md, autoAdjust) => {
    const [breakpoint, setBreakpoint] = useState(getDefaultBreakpoint(md));
    const [screen, setScreen] = useState({});
    const [mdMatchesBrowser, setMdMatchesBrowser] = useState(mdMatchesBrowserCheck(md)); // default we asume it is from cache, mainly need to prevent API call on mount
    const dispatch = useDispatch();
    useEffect(() => {
        if (!mdMatchesBrowserCheck(md)) {
            dispatch(addMdFromUserAgent(window.navigator.userAgent));
        }
        setMdMatchesBrowser(mdMatchesBrowserCheck(md));
    }, [md]);
    const getAngle = (_screen) => {
        var _a;
        return ((_a = _screen === null || _screen === void 0 ? void 0 : _screen.orientation) === null || _a === void 0 ? void 0 : _a.angle) || 0;
    };
    const refreshValue = () => {
        const value = getBreakPointFromCss();
        const next = getAngle(window.screen);
        const prev = getAngle(screen);
        if (breakpoint !== value || next !== prev) {
            const screenInfos = {};
            screenInfos.orientation = Object.assign(Object.assign({}, screenInfos.orientation), { angle: next });
            screenInfos.availWidth = window.screen.availWidth;
            screenInfos.availHeight = window.screen.availHeight;
            screenInfos.colorDepth = window.screen.colorDepth;
            screenInfos.pixelDepth = window.screen.pixelDepth;
            screenInfos.width = window.screen.width;
            screenInfos.height = window.screen.height;
            if (window.screen.orientation) {
                screenInfos.orientation = Object.assign(Object.assign({}, screenInfos.orientation), { type: window.screen.orientation.type });
            }
            setBreakpoint(value);
            setScreen(screenInfos);
        }
    };
    useEffect(() => {
        if (autoAdjust) {
            refreshValue();
        }
        const onResize = throttle(refreshValue, 200, { trailing: true });
        window.addEventListener('resize', onResize);
        window.addEventListener('orientationchange', refreshValue);
        return () => {
            window.removeEventListener('resize', onResize);
            window.removeEventListener('orientationchange', refreshValue);
        };
    }, []);
    return {
        breakpoint,
        screen,
        angle: getAngle(screen),
        md,
        mdMatchesBrowser,
    };
};
export const useBreakpoint = (context = BreakpointContext) => useContext(context);
